import eventManger from '../utilities/EventManager';
import _ from 'lodash';

export const FIELD_TREE_CONSTRUCTOR_BOX = {
  SEARCH_FORM_OPEN: _.uniqueId('ft_search_form_open'), // 検索項目の開閉イベント
  SEARCH_CLEAR: _.uniqueId('ft_search_clear'), // 検索条件クリアイベント
  SEARCH_FORM_RADIO: _.uniqueId('ft_search_rofm_radio'), //検索条件ラジオボタン
  CHANGE_FORM_SHOW: _.uniqueId('ft_change_form_show'), // 編集フォームの表示イベント
  UPDATE_FORM: _.uniqueId('ft_update_form_value'), // 編集内容を保存
  DELETE_USER: _.uniqueId('ft_delete_uuser'), // ユーザーを削除
  DROPDOWN_VALUE: _.uniqueId('ft_dropdown_value'), //ドロップダウン
  DRAG_ITEM: _.uniqueId('ft_drag_item'), //ドラッグアイテム
  ORDER_UPDATE: _.uniqueId('ft_order_update'), //並び替え完了
  SAVE_ORDER: _.uniqueId('ft_save_order'), //並び順を保存
  CSV_EXPORT: _.uniqueId('ft_c_csv_export_dialog'), //CSVダイアログ
  REFRESH_LIST: _.uniqueId('ft_c_refresh_list'), //一覧をリフレッシュs
  NEW_FORM: _.uniqueId('ft_new_form_user'), //新規追加
  ADD_FROM_SEARCH: _.uniqueId('ft_add_from_search'), //検索して追加
  NOW_LOADING: _.uniqueId('ft_now_loading'), // ロード中
};

class Events {
  constructor() {
    for (let key in FIELD_TREE_CONSTRUCTOR_BOX) {
      eventManger.registerEvent(FIELD_TREE_CONSTRUCTOR_BOX[key]);
    }
  }

  removeAll() {
    for (let key in FIELD_TREE_CONSTRUCTOR_BOX) {
      eventManger.deleteEvent(FIELD_TREE_CONSTRUCTOR_BOX[key]);
    }
  }
}

const FieldTreeConstructorBoxEvents = new Events();
export default FieldTreeConstructorBoxEvents;



// WEBPACK FOOTER //
// ./src/components/FieldTreeConstructorBoxEvents.js